import clsx from "clsx"
import { cloneElement, isValidElement } from "react"

import { useComponentNavigation } from "@organisms/ComponentNavigation/ComponentNavigation.context"

import { ComponentNavigationNavigateProps } from "./ComponentNavigationNavigate.types"

export default function ComponentNavigationNavigate(props: ComponentNavigationNavigateProps) {
    const { to, direction = "auto", children, className, onClick, asChild = false } = props
    const { navigate } = useComponentNavigation()

    const handleClick = () => {
        onClick?.()
        navigate(to, direction)
    }

    if (asChild) {
        if (isValidElement(children)) {
            const childElement = children as React.ReactElement<{
                onClick?: (event: React.MouseEvent) => void
                className?: string
            }>

            const mergedClassName = className
                ? clsx(childElement.props.className, className)
                : childElement.props.className

            const mergedOnClick = (event: React.MouseEvent) => {
                childElement.props.onClick?.(event)
                handleClick()
            }

            return cloneElement(childElement, {
                ...childElement.props,
                onClick: mergedOnClick,
                className: mergedClassName,
            })
        }

        return children
    }

    return (
        <button type="button" className={className} onClick={handleClick}>
            {children}
        </button>
    )
}
